import { combineReducers } from "redux";
import torreLml from "./slices/torreLml.slice";

const reducer = combineReducers({
  torreLml,
});

export default reducer;
